import { CheckCircle2 } from "lucide-react";

const POINTS = [
  "Doctor-led",
  "Honest advice",
  "Medical-grade equipment",
  "Evidence-based",
  "Personalized plans",
  "Transparent pricing",
  "Dermatologist Assistance",
  "100% discretion and hygiene",
  "No unnecessary treatments",
];

export function WhyChooseUs() {
  return (
    <section
      className="py-14 bg-gradient-to-br from-primary/5 via-golden/5 to-rose/5"
      aria-labelledby="why-choose-title"
    >
      <div className="container mx-auto px-4 text-center">
        <h2
          id="why-choose-title"
          className="mb-10 text-3xl font-bold md:text-4xl"
        >
          Why Choose <span className="text-golden">SkinSio</span>?
        </h2>
        <div className="mx-auto grid max-w-4xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {POINTS.map((point) => (
            <div
              key={point}
              className="flex items-center gap-3 rounded-xl border border-golden/20 bg-white px-5 py-4 shadow-sm"
            >
              <CheckCircle2
                className="h-6 w-6 flex-shrink-0 text-rose"
                aria-hidden="true"
              />
              <span className="text-left font-semibold text-foreground">
                {point}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
